"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _workOrderConsult = require("@/api/workOrderConsult");

var _sms = require("@/api/sms");

var _goods = require("@/api/goods");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "workOrderConsult",
  components: {},
  data: function data() {
    return {
      listLoading: false,
      dialogFormVisible: false,
      dialogStatus: "",
      smsTemplates: [],
      //短信模板
      textMap: {
        update: "编辑",
        create: "创建"
      },
      rules: {
        name: [{
          required: true,
          message: "咨询名称不能为空",
          trigger: "blur"
        }]
      },
      props: {
        stripe: false,
        // 是否显示间隔斑马纹
        border: false,
        // 是否显示纵向边框
        showHeader: true,
        // 是否显示表头
        showSummary: false,
        // 是否显示表尾合计行
        showRowHover: true,
        // 鼠标悬停时，是否高亮当前行
        showIndex: false,
        // 是否显示数据索引
        treeType: true,
        // 是否为树形表格
        isFold: true,
        // 树形表格中父级是否默认折叠
        expandType: false,
        // 是否为展开行类型表格（为 True 时，需要添加作用域插槽, 它可以获取到 row, rowIndex)
        selectionType: false // 是否显示间隔斑马纹

      },
      list: [],
      typeForm: {
        id: undefined,
        pid: 0,
        name: undefined,
        remark: undefined,
        deleted: false,
        type: 0,
        level: 0
      },
      // 表格标题数据
      columns: [{
        label: "咨询类型",
        prop: "name"
      }, {
        label: '提醒内容',
        prop: 'notify',
        minWidth: "150px",
        type: "template",
        template: "notify"
      }, {
        label: '是否触发邮件',
        prop: 'isMail',
        minWidth: "50px",
        type: "template",
        template: "isMail"
      }, {
        label: "状态",
        prop: "deleted",
        type: "template",
        template: "deleted"
      }, {
        label: "操作",
        type: "template",
        template: "empower"
      }]
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      (0, _workOrderConsult.listConsult)(true).then(function (response) {
        _this.list = response.data.data.list;
        _this.listLoading = false;
      }).catch(function () {
        _this.list = [];
        _this.listLoading = false;
      });
    },
    handleCreate: function handleCreate(data) {
      //console.info(data);
      var pid = data === null ? 0 : data.id;
      var level = data === null ? 1 : data._level + 1;
      var type = data === null ? 0 : data.type; // 咨询类型

      this.typeForm = {
        id: undefined,
        pid: pid,
        name: undefined,
        remark: undefined,
        deleted: false,
        level: level,
        type: type,
        smsId: '',
        isMail: 0
      };
      console.info(this.typeForm);

      if (pid == 0) {
        this.textMap.create = "添加根目录";
      } else {
        this.textMap.create = "添加子项";
      }

      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    handleDelete: function handleDelete(data) {
      var _this2 = this;

      (0, _workOrderConsult.deleteConsult)(data.id).then(function (res) {
        _this2.getList();

        _this2.$notify.success({
          title: "成功",
          message: "停用成功"
        });
      });
    },
    handleEnable: function handleEnable(data) {
      var _this3 = this;

      (0, _workOrderConsult.enableConsult)(data).then(function (res) {
        _this3.getList();

        _this3.$notify.success({
          title: "成功",
          message: "启用成功"
        });
      });
    },
    handleUpdate: function handleUpdate(data) {
      console.info(data);
      var consult = JSON.parse(JSON.stringify(data));
      consult.isMail = consult.isMail == "不触发" ? 0 : 1;
      this.typeForm = consult;
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
    },
    createConsultType: function createConsultType() {
      var _this4 = this;

      this.$refs["typeForm"].validate(function (valid) {
        if (valid) {
          (0, _workOrderConsult.createConsult)(_this4.typeForm).then(function (response) {
            _this4.getList();

            _this4.dialogFormVisible = false;

            _this4.$notify.success({
              title: "成功",
              message: "创建成功"
            });
          }).catch(function (response) {
            _this4.$notify.error({
              title: "失败",
              message: response.data.errmsg
            });
          });
        }
      });
    },
    updateConsultType: function updateConsultType() {
      var _this5 = this;

      this.$refs["typeForm"].validate(function (valid) {
        if (valid) {
          (0, _workOrderConsult.updateConsult)(_this5.typeForm).then(function () {
            _this5.getList();

            _this5.dialogFormVisible = false;

            _this5.$notify.success({
              title: "成功",
              message: "更新成功"
            });
          }).catch(function (response) {
            _this5.$notify.error({
              title: "失败",
              message: response.data.errmsg
            });
          });
        }
      });
    }
  }
};
exports.default = _default;